<template>
    <div class="flex flex-col content-center justify-center max-w-sm mx-4 mx-auto lg:w-full lg:max-w-md">
        <div class="flex justify-center text-4xl font-semibold text-gray-900">Welcome Back!</div>
        <div class="flex justify-center block text-sm lg:hidden">
            <span class="text-gray-600"
                >Not using Flowist?
                <router-link tag="a" class="font-bold text-gray-700 underline" to="/signup">
                    Sign up
                </router-link>
            </span>
        </div>
        <form @submit.prevent="signin" class="items-center w-full mt-8">
            <p v-if="error !== ''" class="flex justify-center py-2 text-sm font-semibold text-red-500">{{ error }}</p>
            <p v-if="message !== undefined" class="flex justify-center px-4 py-2 mb-4 text-sm text-green-500 bg-green-100 rounded-md">{{ message }}</p>
            <fieldset class="mb-3 form-group">
                <label class="block mb-1 text-sm font-semibold text-gray-700" for="Email">Email</label>
                <input class="py-3 input focus:outline-none focus:border-gray-700" id="email" v-model="$v.email.$model" type="text" placeholder="Email" />
                <div v-if="$v.email.$error">
                    <p v-if="!$v.email.required" class="py-2 text-sm font-semibold text-red-500">
                        Your email is required
                    </p>
                </div>
            </fieldset>
            <fieldset class="mb-4 form-group">
                <label class="block mb-1 text-sm font-semibold text-gray-700">Password</label>
                <input class="py-3 input focus:outline-none focus:border-gray-700" type="password" v-model="$v.password.$model" placeholder="Password" />
                <div v-if="$v.password.$error">
                    <p v-if="!$v.password.required" class="py-2 text-sm font-semibold text-red-500">
                        A password is required
                    </p>
                </div>
            </fieldset>
            <div class="flex items-center justify-between mt-6 mb-4">
                <div class="flex items-center">
                    <input id="remember_me" type="checkbox" v-model="remember_me" class="w-4 h-4 transition duration-150 ease-in-out form-checkbox text-primary-500" />
                    <label for="remember_me" class="block ml-2 text-sm leading-5 text-gray-900">
                        Remember me
                    </label>
                </div>

                <div class="text-sm leading-5">
                    <router-link
                        tag="a"
                        to="/password_resets"
                        class="font-medium text-gray-900 underline transition duration-150 ease-in-out hover:text-gray-700 focus:outline-none focus:underline"
                    >
                        Forgot your password?
                    </router-link>
                </div>
            </div>
            <loading-button type="submit" :loading="loading" text="Sign in">
                Sign In
                <svg class="w-6 h-6 fill-current" viewBox="0 0 24 24">
                    <path
                        d="M14.5857864,13 L7,13 C6.44771525,13 6,12.5522847 6,12 C6,11.4477153 6.44771525,11 7,11 L14.5857864,11 L12.2928932,8.70710678 C11.9023689,8.31658249 11.9023689,7.68341751 12.2928932,7.29289322 C12.6834175,6.90236893 13.3165825,6.90236893 13.7071068,7.29289322 L17.7071068,11.2928932 C18.0976311,11.6834175 18.0976311,12.3165825 17.7071068,12.7071068 L13.7071068,16.7071068 C13.3165825,17.0976311 12.6834175,17.0976311 12.2928932,16.7071068 C11.9023689,16.3165825 11.9023689,15.6834175 12.2928932,15.2928932 L14.5857864,13 Z"
                    />
                </svg>
            </loading-button>
        </form>
    </div>
</template>

<script>
import LoadingButton from '@/components/LoadingButton';
import { required, minLength, email } from 'vuelidate/lib/validators';

export default {
    name: 'signin-account',
    components: { LoadingButton },
    props: {
        message: String,
        redirectToPrevious: Boolean,
    },
    data() {
        return {
            loading: false,
            email: '',
            password: '',
            remember_me: true,
            error: '',
        };
    },
    methods: {
        signin() {
            const { email, password, remember_me } = this;
            if (this.$v.$invalid) {
                this.error = 'Email and password are required';
            } else {
                this.loading = true;
                this.$store
                    .dispatch('users/signin', {
                        session: {
                            email: this.email.trim().toLowerCase(),
                            password,
                            remember_me,
                        },
                    })
                    .then(() => {
                        if (this.redirectToPrevious) {
                            this.$router.go(-1);
                        } else {
                            this.$router.push('/dashboard');
                        }
                    })
                    .catch(err => {
                        this.error = 'Email or password were incorrect.';
                        this.loading = false;
                    });
            }
        },
    },
    validations: {
        email: {
            required,
        },
        password: {
            required,
        },
    },
};
</script>
